import styles from './MobileNavigation.module.css'
import { Link } from 'react-router-dom'
import navCloseIcon from '../../assets/icons/nav-close.svg'
import SocialLink from '../UI/SocialLink'
import whatsappImg from "../../assets/icons/whatsapp.png";
import facebookImg from "../../assets/icons/facebook.png";
import instagramImg from "../../assets/icons/instagram.png";
import chevronRight from '../../assets/icons/chevron-right.svg'

const MobileNavigation = (props) => {
    return <nav className={styles.navbar}>
        <div onClick={props.onClick} className={styles.iconContainer}>
            <img className={styles.icon} src={navCloseIcon} alt='Close Navigation Icon' />
        </div>
        <ul className={styles.links}>
            <li className={styles.linkContainer}>
                <Link
                    to="/"
                >
                    Home
                </Link>
                <img src={chevronRight} alt='Right Icon' />
            </li>
            <li className={styles.linkContainer}>
                <Link
                    to="/gallery"
                >
                    Gallery
                </Link>
                <img src={chevronRight} alt='Right Icon' />
            </li>
            <li className={styles.linkContainer}>
                <Link
                    to="/about"
                >
                    About Us
                </Link>
                <img src={chevronRight} alt='Right Icon' />
            </li>
            <li className={styles.linkContainer}>
                <Link
                    to="/contact"
                >
                    Contact Us
                </Link>
                <img src={chevronRight} alt='Right Icon' />
            </li>
        </ul>
        <div className={styles.linksContainer}>
            <SocialLink linkClassName={styles.linkIconContainer} href="#" src={whatsappImg} alt="whatsapp" />
            <SocialLink linkClassName={styles.linkIconContainer} href="#" src={instagramImg} alt="instagram" />
            <SocialLink
                linkClassName={styles.linkIconContainer}
                imgClassName={styles.linkImg}
                href="#"
                src={facebookImg}
                alt="facebook"
            />
        </div>
    </nav>
}

export default MobileNavigation